import { render } from "./pop-modal.vue?vue&type=template&id=60447a06&scoped=true&ts=true"
import script from "./pop-modal.vue?vue&type=script&lang=ts"
export * from "./pop-modal.vue?vue&type=script&lang=ts"

import "./pop-modal.vue?vue&type=style&index=0&id=60447a06&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60447a06"]])

export default __exports__